interface JiraOption {
	id: string;
	value: string;
	__typename: string; // This will always be 'JiraOption' in this context
}

interface JiraCascadingOptions {
	parentOptionValue: JiraOption;
	childOptionValues: JiraOption[];
	__typename: string; // This will always be 'JiraCascadingOptions' in this context
}

export type JiraCascadingOptionsArray = JiraCascadingOptions[];

type JiraCascadingOption = {
	parentOptionValue: JiraOption | null;
	childOptionValue: JiraOption | null;
	__typename: string;
};

const getExpectedParentOption = (parentOptionId: unknown) => {
	if (typeof parentOptionId === 'string') return parentOptionId;

	if (typeof parentOptionId === 'number') return parentOptionId.toString();

	if (Array.isArray(parentOptionId) && parentOptionId.length > 0)
		return parentOptionId[0].toString();

	return null;
};

const getExpectedParentAndChildOption = (parentOptionId: unknown, childOptionId: unknown) => {
	const expectedParentOptionId = getExpectedParentOption(parentOptionId);

	if (!expectedParentOptionId) {
		return null;
	}

	if (typeof childOptionId === 'string') {
		return {
			parentOptionId: expectedParentOptionId,
			childOptionId,
		};
	}
	if (typeof childOptionId === 'number') {
		return {
			parentOptionId: expectedParentOptionId,
			childOptionId: childOptionId.toString(),
		};
	}
	if (Array.isArray(childOptionId) && childOptionId.length > 0) {
		return {
			parentOptionId: expectedParentOptionId,
			childOptionId: childOptionId[0].toString(),
		};
	}
	return {
		parentOptionId: expectedParentOptionId,
		childOptionId: null,
	};
};

export const getCascadingSelectFieldValue = ({
	parentOptionId,
	childOptionId,
	allowedValues,
}: {
	parentOptionId: unknown;
	childOptionId: unknown;
	allowedValues: JiraCascadingOptionsArray;
}) => {
	if (!Array.isArray(allowedValues)) return null;

	const expectedFieldValue = getExpectedParentAndChildOption(parentOptionId, childOptionId);
	if (!expectedFieldValue) return null;

	const defaultValue: JiraCascadingOption = {
		parentOptionValue: null,
		childOptionValue: null,
		__typename: 'JiraCascadingOption',
	};

	for (const parentValue of allowedValues) {
		if (parentValue.parentOptionValue.id === expectedFieldValue.parentOptionId) {
			defaultValue.parentOptionValue = parentValue.parentOptionValue;
			for (const childValue of parentValue.childOptionValues) {
				if (childValue.id === expectedFieldValue.childOptionId) {
					defaultValue.childOptionValue = childValue;
					return defaultValue;
				}
			}
			return defaultValue;
		}
	}

	return null;
};
